export default __webpack_public_path__ + "static/media/pcg.6b926176.svg";